export default __webpack_public_path__ + "static/media/quote.4a60817a.webp";